import create from "zustand";
import zukeeper from 'zukeeper';


interface IChartStore {
  isAutoRange: boolean;
  isBarChartOn: boolean;
  viewType: 'bar' | 'line' | 'table' | 'userBar' | 'userLine';
  isSinglePressureChart: boolean;
  isThresholdsOn: boolean;
  showLegend: boolean;
  aggregator: string;
  visibleDataSeries: { [key: string]: boolean;}
  visibleRange: { min: number | undefined; max: number | undefined; };
  visibleSeriesActivity: { [key: string]: boolean;}
  visibleSeriesStatus: { [key: string]: boolean;}
  visibleSeriesCompliance: { [key: string]: boolean;}
  visibleSeriesActivityPressure: { [key: string]: boolean;}
  visibleSeriesActivityFlowRate: { [key: string]: boolean;}
  visibleSeriesDiagnostics: { [key: string]: boolean;}
  visibleSeriesAsset: { [key: string]: boolean;}
  setVisibleDataSeries: (name: string, isVisible: boolean) => void;
  setAutoRange: (isAutoRange: boolean) => void;
  setBarChartOn: (isBarChartOn: boolean) => void;
  setViewType: (viewType: 'bar' | 'line' | 'table' | 'userBar' | 'userLine') => void;
  setAggregator: (aggregator: string) => void;
  setSinglePressureChart: (isSinglePressureChart: boolean) => void;
  setThresholdsOn: (isThresholdsOn: boolean) => void;
  setShowLegend: (showLegend: boolean) => void;
  setVisibleRange: (min: number | undefined, max: number | undefined) => void;
  setVisibleSeriesActivity: (name: string, isVisible: boolean) => void;
  setVisibleSeriesStatus: (name: string, isVisible: boolean) => void;
  setVisibleSeriesCompliance: (name: string, isVisible: boolean) => void;
  setVisibleSeriesActivityPressure: (name: string, isVisible: boolean) => void;
  setVisibleSeriesActivityFlowRate: (name: string, isVisible: boolean) => void;
  setVisibleSeriesDiagnostics: (name: string, isVisible: boolean) => void;
  setVisibleSeriesAsset: (name: string, isVisible: boolean) => void;
  visibleSeriesTimeline: { [key: string]: boolean;}
  setVisibleSeriesTimeline: (name: string, isVisible: boolean) => void;
}

/**
 * This store allows us to access the current user identity anywhere in the application.
 */
const useChartStore = create<IChartStore>(zukeeper((set) => ({
  visibleDataSeries: {},
  setVisibleDataSeries: (name: string, isVisible: boolean) => {
    set((state) => {
      return {
        visibleDataSeries: {...state.visibleDataSeries, [name]: isVisible },
      };
    });
  },
  isAutoRange: false,
  setAutoRange: (isAutoRange: boolean) => {
    set(() => {
      return {
        isAutoRange: isAutoRange,
      };
    });
  },
  isBarChartOn: true,
  setBarChartOn: (isBarChartOn: boolean) => {
    set(() => {
      return {
        isBarChartOn: isBarChartOn,
      };
    });
  },
  viewType: 'bar',
  setViewType: (viewType: 'bar' | 'line' | 'table' | 'userBar' | 'userLine') => {
    set(() => {
      return {
        viewType: viewType,
      };
    });
  },
  aggregator: 'none',
  setAggregator: (aggregator: string) => {
    set(() => {
      return {
        aggregator: aggregator,
      };
    });
  },
  isSinglePressureChart: true,
  setSinglePressureChart: (isSinglePressureChart: boolean) => {
    set(() => {
      return {
        isSinglePressureChart: isSinglePressureChart,
      };
    });
  },
  isThresholdsOn: true,
  setThresholdsOn: (isThresholdsOn: boolean) => {
    set(() => {
      return {
        isThresholdsOn: isThresholdsOn,
      };
    });
  },
  showLegend: true,
  setShowLegend: (showLegend: boolean) => {
    set(() => {
      return {
        showLegend: showLegend,
      };
    });
  },
  visibleRange: { min: undefined, max: undefined },
  setVisibleRange: (min: number | undefined, max: number | undefined) => {
    set(() => {
      return {
        visibleRange: { min: min, max: max },
      };
    });
  },
  visibleSeriesActivity: {},
  setVisibleSeriesActivity: (name: string, isVisible: boolean) => {
    set((state) => {
      return {
        visibleSeriesActivity: {...state.visibleSeriesActivity, [name]: isVisible },
      };
    });
  },
  visibleSeriesStatus: {},
  setVisibleSeriesStatus: (name: string, isVisible: boolean) => {
    set((state) => {
      return {
        visibleSeriesStatus: {...state.visibleSeriesStatus, [name]: isVisible },
      };
    });
  },
  visibleSeriesCompliance: {},
  setVisibleSeriesCompliance: (name: string, isVisible: boolean) => {
    set((state) => {
      return {
        visibleSeriesCompliance: {...state.visibleSeriesCompliance, [name]: isVisible },
      };
    });
  },
  visibleSeriesActivityPressure: {},
  setVisibleSeriesActivityPressure: (name: string, isVisible: boolean) => {
    set((state) => {
      return {
        visibleSeriesActivityPressure: {...state.visibleSeriesActivityPressure, [name]: isVisible },
      };
    });
  },
  visibleSeriesActivityFlowRate: {},
  setVisibleSeriesActivityFlowRate: (name: string, isVisible: boolean) => {
    set((state) => {
      return {
        visibleSeriesActivityFlowRate: {...state.visibleSeriesActivityFlowRate, [name]: isVisible },
      };
    });
  },
  visibleSeriesDiagnostics: {},
  setVisibleSeriesDiagnostics: (name: string, isVisible: boolean) => {
    set((state) => {
      return {
        visibleSeriesDiagnostics: {...state.visibleSeriesDiagnostics, [name]: isVisible },
      };
    });
  },
  visibleSeriesAsset: {},
  setVisibleSeriesAsset: (name: string, isVisible: boolean) => {
    set((state) => {
      return {
        visibleSeriesAsset: {...state.visibleSeriesAsset, [name]: isVisible },
      };
    });
  },
  visibleSeriesTimeline: {},
  setVisibleSeriesTimeline: (name: string, isVisible: boolean) => {
    set((state) => {
      return {
        visibleSeriesTimeline: {...state.visibleSeriesTimeline, [name]: isVisible },
      };
    });
  },
})));

export default useChartStore;
